import { ROUTES } from "@nf/constants";
import React, { memo } from "react";
import { useTranslation } from "next-i18next";
import cx from "classnames";

import Button from "components/Button";
import { useScrolled, useSignUpUrl } from "hooks";
import { useIsLoading } from "helpers/setIsLoadingContext";

import styles from "./LandingPageHeader.module.scss";

export const LandingPageHeader = memo(() => {
  const { t } = useTranslation("translations");
  const { isLoading } = useIsLoading();
  const signUpUrl = useSignUpUrl();
  const isPageScrolledDown = useScrolled();

  if (isLoading) {
    return null;
  }

  return (
    <div
      className={cx(styles.container, {
        [styles.background]: isPageScrolledDown,
      })}
    >
      <Button
        href={signUpUrl}
        size="small"
        variant="primary"
        className={styles.button}
      >
        {t("web_create_account_link")}
      </Button>

      <Button
        href={ROUTES.LOGIN}
        size="small"
        variant="secondary"
        className={cx(styles.button, styles.border)}
      >
        {t("web_login_button")}
      </Button>
    </div>
  );
});

export default LandingPageHeader;
